import {match} from 'ts-pattern';

import type {BusinessCaseResponseBody} from '@dms/api/sales';

import type {BusinessCaseState} from '@prompt-bridge/shared/ai-assistant-core';

export const toBusinessCaseState = (
  state: BusinessCaseResponseBody['businessCaseState']
): BusinessCaseState | null =>
  match(state)
    .returnType<BusinessCaseState | null>()
    .with('OFFER', 'CONTRACT', 'DEPOSIT', 'DEPOSIT_PAID', 'INVOICE', 'PAID', (value) => value)
    .with('CONCEPT', 'CLOSED', 'UNSUCCESSFUL', () => null)
    .exhaustive();
